//import Alpine from 'alpinejs';
import { Transitions } from '../transitions';

import {
  Solar,
} from '../solar';
import {
  Carousel,
  Store,
  Menu,
} from '../util';

const preloader = document.querySelector('.preloader');

export const Common = {
  init() {
    // Note: Alpine is provided by Livewire 3.x - do NOT call Alpine.start() again
    // as it causes "Detected multiple instances of Alpine running" error
    // Livewire automatically initializes Alpine, so we just use window.Alpine
    if (typeof Alpine === 'undefined') {
      console.warn('Alpine is not defined yet - this should not happen with Livewire 3.x');
      return;
    }

    Menu.init();
    Store.setup();
    Solar.start();
    Carousel.init();
    if (preloader) {
      preloader.classList.remove('is-loading');
    }
  },
  finalize() {
    // Verificar que existen los objetos necesarios antes de usarlos
    if (window.useInertia && typeof window.useInertia.before === 'function') {
      window.useInertia.before(() => {
        // Código cuando before es llamado
      });
    }

    if (window.useInertia && typeof window.useInertia.after === 'function') {
      window.useInertia.after(() => {
        Carousel.init();
      });
    }

    // Verificar que window.inertia existe y tiene setup antes de usarlo
    if (window.inertia && window.inertia.setup) {
      try {
        window.inertia.setup.transitions = Transitions;
        if (typeof window.inertia.init === 'function') {
          window.inertia.init(window.inertia.setup);
        }
      } catch (error) {
        console.warn('Error configurando Barba.js:', error);
      }
    }
  },
};
